import React from "react";
import ImageGrid from "../../../components/company_grid";
import Footer from "../../../components/footer";
import LeadershipHeroSection from "../leadership/leadership_page";
import DirectorProfile from "../leadership/director_profile";

function Home() {
  return (
    <div>
      <LeadershipHeroSection/>
      <DirectorProfile />
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Home;
